import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import PlacementInvoice from 'src/app/model/invoice/placement-invoice';
import { BaseProject } from 'src/app/model/project/base-project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'ip-board-invoicing',
  templateUrl: './ip-board-invoicing.component.html',
  styleUrls: ['./ip-board-invoicing.component.scss'],
})
export class IPBoardInvoicingComponent implements OnInit {
  @Input()
  baseProject: BaseProject;
  @Input()
  collaborative: boolean = false;
  @Input()
  showSave = false;
  @Input()
  savingLines = false;
  @Output()
  save = new EventEmitter<any>();
  @Output()
  saveLines = new EventEmitter();

  @Input()
  showTitle: boolean = true;

  @Output()
  divergentPricesChecked = new EventEmitter();

  divergentPricesOnly: boolean = false;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  ngOnInit(): void {
    this.divergentPricesOnly =
      CollectionHelper.isPopulated(this.baseProject.projectInvoices) &&
      this.baseProject.projectInvoices.some(
        (pi) =>
          pi.type === 'PlacementInvoice' &&
          (<PlacementInvoice>pi).onlyChargePriceLines
      );
  }

  divergentPricesOnlyChanged(): void {
    if (CollectionHelper.isPopulated(this.baseProject.projectInvoices)) {
      this.baseProject.projectInvoices.forEach((pi) => {
        if (pi.type === 'PlacementInvoice') {
          (<PlacementInvoice>pi).onlyChargePriceLines =
            this.divergentPricesOnly;
        }
      });
      this.projectDisplayObservableService
        .getProjectInvoicePriceChangedSubscribable()
        .next();
    }
    this.divergentPricesChecked.emit(this.divergentPricesOnly);
    this.save.emit();
  }
}
